// extracted by mini-css-extract-plugin
export var avatarContainer = "_fr-0";
export var gray = "_fr-f";
export var green = "_fr-c";
export var icon = "_fr-9";
export var image = "_fr-1";
export var lg = "_fr-6";
export var md = "_fr-5";
export var presenceDot = "_fr-b";
export var red = "_fr-d";
export var sm = "_fr-4";
export var status = "_fr-a";
export var xl = "_fr-7";
export var xs = "_fr-3";
export var xxl = "_fr-8";
export var xxs = "_fr-2";
export var yellow = "_fr-e";